var OrderFormPortingItem = /*@__PURE__*/ (function () {
    function OrderFormPortingItem() {
        this.uc = '';
    }
    OrderFormPortingItem.prototype.getMsisdn = function () {
        return this.msisdn;
    };
    OrderFormPortingItem.prototype.setMsisdn = function (msisdn) {
        this.msisdn = msisdn;
        return this;
    };
    OrderFormPortingItem.prototype.getUc = function () {
        return this.uc;
    };
    OrderFormPortingItem.prototype.setUc = function (uc) {
        this.uc = uc;
        return this;
    };
    OrderFormPortingItem.prototype.getBundleId = function () {
        return this.bundle_id;
    };
    OrderFormPortingItem.prototype.setBundleId = function (bundleId) {
        this.bundle_id = bundleId;
        return this;
    };
    OrderFormPortingItem.prototype.getTariffName = function () {
        return this.tariff_nam;
    };
    OrderFormPortingItem.prototype.setTariffName = function (name) {
        this.tariff_nam = name;
        return this;
    };
    OrderFormPortingItem.prototype.getPosition = function () {
        return this.position;
    };
    OrderFormPortingItem.prototype.setPosition = function (position) {
        this.position = position;
        return this;
    };
    return OrderFormPortingItem;
}());
export { OrderFormPortingItem };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.form-porting-item.ts
// module id = null
// module chunks = 